module.exports = __webpack_public_path__ + "static/img/img190.dcfe346.png";


//////////////////
// WEBPACK FOOTER
// ./assets/img/img190.png
// module id = YhCi
// module chunks = 5